import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  validationUserList: {
    maxHeight: "400px",
    overflow: "auto",
    width: "100%",
  },
}));
